import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import AForm, { useForm, useWatch } from "./hack/Form";
import React from "react";
import { getPrefixCls } from "../config";
import { FormItem } from "./FormItem";
import useFormInstance from "./hack/hooks/useFormInstance";
import { jsx as _jsx } from "react/jsx-runtime";
export function Form(props) {
  var prefixCls = getPrefixCls("form");
  return /*#__PURE__*/_jsx(AForm, _objectSpread({
    prefixCls: prefixCls
  }, props));
}
Form.Item = FormItem;
Form.useForm = useForm;
Form.useWatch = useWatch;
Form.useFormInstance = useFormInstance;